// export const TELEGRAM_LINK = 'https://t.me/BernardBondsOfficial';
export const TWITTER_LINK = 'https://x.com/G1Erik';
// export const FACEBOOK_LINK = 'https://www.facebook.com/ryan.jaenicke';
// export const INSTAGRAM_LINK =
('https://www.instagram.com/degeneratepassiveincome/');
// export const TIKTOK_LINK = 'https://www.tiktok.com/@degeneratepassiveincome';
